module.exports = __webpack_public_path__ + "img/Doc16b_20070019-036.25b79d67.jpg";